import request from '@/utils/request'

// 获取分页列表
export function getPageList(params) {
  return request({
    url: '/member-area-management/pageList',
    method: 'get',
    params
  })
}

// 刷新缓存
export function refreshAreaContactCache(params) {
  return request({
    url: '/member-area-management/refreshAreaContactCache',
    method: 'get',
    params
  })
}

// 获取成员列表
export function getMembersList() {
  return request({
    url: '/member-area-management/getMembersList',
    method: 'get'
  })
}

// 删除记录（注意：组件中使用的是GET请求）
export function deleteMemberArea(params) {
  return request({
    url: '/member-area-management/delete',
    method: 'get',
    params
  })
}

// 新增保存
export function saveMemberArea(data) {
  return request({
    url: '/member-area-management/save',
    method: 'post',
    data
  })
}

// 更新
export function updateMemberArea(data) {
  return request({
    url: '/member-area-management/update',
    method: 'post',
    data
  })
}
